var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "GlobeIcon",
  transform: "translate(-568 -320)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_362",
  "data-name": "Path 362",
  d: "M312.521,36.855l-5.009,3.34-8.349-1.67-5.009-1.67-6.679,1.67-5.009-1.67,3.339-6.679h6.679l6.546-3.273A47.825,47.825,0,0,1,312.521,36.855Z",
  transform: "translate(338.12 298.173)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_363",
  "data-name": "Path 363",
  d: "M61.226,23.446l-1.67,5.009-5.009,1.67-5.009,8.349-8.349,5.009L29.5,45.154v5.009L32.84,53.5v6.679l-5.009-3.34L22.821,53.5,19.916,44.77A48.393,48.393,0,0,1,46.466,18.6l4.742,3.173Z",
  transform: "translate(551.851 304.902)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_364",
  "data-name": "Path 364",
  d: "M105.656,226.969l-1.67,8.349L97.307,242v5.009l-6.679,5.009v8.349l-5.009-1.67-3.34-8.349v-16.7l-8.349-1.67L70.59,225.3V220.29l3.34-3.339,5.009-5.009,3.34,6.679H93.967l5.009,8.349Z",
  transform: "translate(510.761 147.318)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_365",
  "data-name": "Path 365",
  d: "M312.545,117.876a48.072,48.072,0,0,1-2.672,51.369l-4.508-4.493V158.1l-3.34-6.656-3.339-6.656v-6.656l-5.009-3.328L287,136.463l-11.688-4.992-1.67-11.648,5.009-4.992h10.019l3.34,4.992,10.019,1.664,10.019-3.328Z",
  transform: "translate(345.277 226.249)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_366",
  "data-name": "Path 366",
  d: "M57.894,16.624l6.617-1.656,4.963,1.656,8.272,1.656,4.963-3.311a47.283,47.283,0,0,1,7.113,9.653l-.5.282L79.4,28.214l-9.926-1.656-3.309-4.967H56.24l-4.963,4.967,1.654,11.59,11.58,4.967,6.617-1.656,4.963,3.311v6.623L79.4,58.017l3.309,6.623v6.623l4.467,4.47A47.983,47.983,0,0,1,3.732,29.488l2.878,8.659,4.963,3.311,4.963,3.311-3.309,3.312v4.967l3.309,6.623,8.272,1.656V77.885l3.309,8.279,4.963,1.656V79.541L39.7,74.574V69.606l6.617-6.623L47.968,54.7H41.351l-4.963-8.279H24.808L21.5,39.8l-4.963,4.967V38.148l-3.309-3.311V29.869l11.58-1.656,8.272-4.967,4.963-8.279,4.963-1.656L44.66,8.345,34.734,6.689l-4.7-3.146A47.941,47.941,0,0,1,69.342,5.1L62.857,8.345H56.24l-3.309,6.623Z",
  transform: "translate(568 319.933)",
  fill: "#86daf1"
}))));
export default __webpack_public_path__ + "static/media/globalflag2.92f3b2ed.svg";
export { SvgComponent as ReactComponent };